import { IconWrapper } from '../runtime';
export default IconWrapper('follow-document-update', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6 14.2498H3.75C2.64543 14.2498 1.75 13.3543 1.75 12.2498V3.74976C1.75 2.64519 2.64543 1.74976 3.75 1.74976H10.75C11.8546 1.74976 12.75 2.64519 12.75 3.74976V6",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.5 5.49976H10M8.25 13.2498H14.75M14 13.2498V10.7498C14 9.36904 12.8807 8.24976 11.5 8.24976C10.1193 8.24976 9 9.36904 9 10.7498V13.2498",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10 13.2498H13V13.9998C13 14.8282 12.3284 15.4998 11.5 15.4998C10.6716 15.4998 10 14.8282 10 13.9998V13.2498Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});